<template lang="pug">
  .agencies
    PhoValidationProvider(:rules="rules" :name="$t($lang.agency.AGENCY)")
      v-autocomplete.nowrap(
        v-model="lazyValue"
        dense
        outlined
        clearable
        attach
        item-value="agencyId"
        item-text="name"
        :menu-props="{maxHeight:150}"
        :multiple="multiple"
        :items="lazyAgencies"
        :label="$t($lang.agency.AGENCY)"
        :placeholder="$t($lang.app.CHOOSE)"
        :search-input.sync="search"
        @change="clearSearch"
      )
</template>
<script>
import { onMounted, ref, watch } from 'vue';
import { useModelAutoBinding } from '@/helpers/misc/binding';
import { filterSelectedValues } from '@/helpers/content';
import { getAgencies } from '@/api/agency/AgencyContentApi';
import { PhoValidationProvider } from '@/components/misc/form';
import { isNullOrEmpty, useSelectedSorter } from '@/helpers/misc';

export default {
  name: 'Agencies',
  components: {
    PhoValidationProvider,
  },
  props: {
    value: {
      type: [Array, String],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    contentTypes: {
      type: Array,
      default: () => ([]),
    },
    tabName: {
      type: String,
    },
    rules: {
      type: String,
      default: '',
    },
  },

  setup(props, { emit }) {
    const { lazyValue } = useModelAutoBinding(emit, props);

    const lazyItems = ref([]);
    const search = ref('');

    const clearSearch = () => {
      search.value = '';
    };

    const loadAgencies = async (contentTypes, tabName) => {
      if (!contentTypes.length) {
        return;
      }

      lazyItems.value = await getAgencies(contentTypes, isNullOrEmpty(tabName) ? null : tabName);
    };

    watch(() => props.contentTypes, async newValue => {
      await loadAgencies(newValue, props.tabName);
      search.value = '';
    });

    watch(() => props.tabName, async newValue => {
      await loadAgencies(props.contentTypes, newValue);
      search.value = '';
    });

    onMounted(async () => {
      await loadAgencies(props.contentTypes, props.tabName);
    });

    const [lazyAgencies] = useSelectedSorter(lazyItems, lazyValue, filterSelectedValues, 'agencyId');

    return {
      search,
      lazyValue,
      clearSearch,
      lazyItems,
      lazyAgencies,
    };
  },
};
</script>
